import Script from 'next/script'

const UseproofCode = () => {
  return (
    process.env.NODE_ENV === 'production' && (
      <Script
        id="provesource"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
!function(o,i){window.provesrc&&window.console&&console.error&&console.error("ProveSource is included twice in this page."),provesrc=window.provesrc={dq:[],display:function(){this.dq.push(arguments)}},o._provesrcAsyncInit=function(){provesrc.init({apiKey:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50SWQiOiI2OWEzOTI3MWI3YmRhYWM4NjRmMWIzZGQiLCJpYXQiOjE3NzIzMjc1Mzd9.HfiPIMi9GAQSJJMSAYdQtf3qaltvxCMWATDMkpPQ52w",v:"0.0.4"})};var r=i.createElement("script");r.type="text/javascript",r.async=!0,r["ch"+"ar"+"set"]="UTF-8",r.src="https://cdn.provesrc.com/provesrc.js";var e=i.getElementsByTagName("script")[0];e.parentNode.insertBefore(r,e)}(window,document);
          `
        }}
      />
    )
  )
}

export default UseproofCode
